module.exports = __webpack_public_path__ + "sprstatic/img/xin (4).f30a49d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xin/xin (4).png
// module id = yqiA
// module chunks = 2